import AdminCoachRoute from './AdminCoachRoute';

export default AdminCoachRoute;
